"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
var React = __importStar(require("react"));
var bind_1 = __importDefault(require("classnames/bind"));
var styles = __importStar(require("./styles.modules.css"));
var cx = bind_1.default.bind(styles);
var defaultProps = {
    tag: "p",
};
var Text = function (props) {
    var _a;
    var tag = props.tag, value = props.value, children = props.children, className = props.className, dangerous = props.dangerous;
    var className_ = cx((_a = {},
        _a[className] = className,
        _a[tag] = true,
        _a));
    var Tag = tag;
    var body = value ? value : children;
    if (dangerous) {
        return (React.createElement(Tag, { dangerouslySetInnerHTML: { __html: body }, className: className_ }));
    }
    return React.createElement(Tag, { className: className_ }, body);
};
exports.Text = Text;
Text.defaultProps = defaultProps;
//# sourceMappingURL=text.js.map